module.exports = __webpack_public_path__ + "img/com7.5d12a3b0.gif";